import FusionAuthService from './fusionAuthService';

export default FusionAuthService;
